<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
@import './assets/sass/common.scss';
@import url('./assets/sass/flex.css');
@import url('../static/fa/css/font-awesome.css');
@import url('//at.alicdn.com/t/c/font_1665910_82wzvyygwcg.css');
.condition .el-input__inner{
    height: 30px!important;
    padding: 0 10px;
    line-height: 30px!important;
}
.condition .el-input__icon{
    line-height: 30px;
}
.select-course .el-table__header th{
    background: $c-bg-table-header;
}
img{
    max-width: 100%!important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue